import { render, staticRenderFns } from "./Program.vue?vue&type=template&id=40ddfe4e&scoped=true&lang=pug&"
import script from "./Program.vue?vue&type=script&lang=ts&"
export * from "./Program.vue?vue&type=script&lang=ts&"
import style0 from "./Program.vue?vue&type=style&index=0&id=40ddfe4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ddfe4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
